/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download-button': {
    width: 41,
    height: 41,
    viewBox: '0 0 41 41',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" cx="20" cy="20" r="20" _fill="#FED300" transform="translate(.766 .708)"/><g _stroke="#4A4A4A" stroke-linecap="round" stroke-width="2"><path pid="1" stroke-linejoin="round" d="M25.906 16.929l-5.363 5.717-5.363-5.717"/><path pid="2" d="M20.543 22.031V11.045"/><path pid="3" stroke-linejoin="round" d="M13.037 23.565v4.583h15.157v-4.583"/></g></g>'
  }
})
